import { NgModule } from '@angular/core';

import { UiSwitchComponent } from './ui-switch.component';

@NgModule({
    declarations: [UiSwitchComponent],
    exports: [UiSwitchComponent]
})
export class UiSwitchModule {
}


/** WEBPACK FOOTER **
 ** ./src/index.ts
 **/